/** Calculate the visible page without adding conversation-specific identity or reset policy: clamp an
 *  outdated page to the last one and slice its items. Filter reset and page-size state stay with the
 *  caller. Plugin bundles receive this same function as `ElowenUiRuntime.utils.paginateItems`. */
export function paginateItems<T>(items: readonly T[], requestedPage: number, pageSize: number): { page: number; items: T[] } {
  const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
  const page = Math.min(requestedPage, pageCount - 1);
  return { page, items: items.slice(page * pageSize, page * pageSize + pageSize) };
}
